// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Modal_Overlay__2kgyc","Modal":"Modal_Modal__2a2SL"};